// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__yIJpi","label":"Section_label__2FYlY","contentWrap":"Section_contentWrap__2a91o","footer":"Section_footer__29MHt","footerInner":"Section_footerInner__C1Iy5"};